import BrazeContentCardsWrapper from './braze-content-cards';
import BrazeIamWrapper from './braze-iam';

export default [
    new BrazeContentCardsWrapper('js-braze-content-cards-wrapper'),
    new BrazeIamWrapper('js-braze-iam-wrapper'),
];
